import classNames from "classnames";
import React, { useState } from "react";
import { TextareaAutosize } from "../../../../dashboard/TextareaAutosize";

export function SeshTextarea(props: {
	value: string;
	onChange: (e: React.ChangeEvent<HTMLTextAreaElement>) => void;
	placeholder?: string;
	rows?: number;
	maxRows?: number;
	disabled?: boolean;
	className?: string;
}) {
	const [isFocused, setIsFocused] = useState(false);

	return (
		<div
			className={classNames(
				"flex w-full rounded-[4px] border-2 bg-base-dark text-content-primary outline-none",
				props.className,
				{
					"input-disabled": props.disabled,
					"border-sesh-primary shadow-input-focus": isFocused,
					"border-content-secondary hover:border-sesh-dark":
						!isFocused,
				}
			)}
		>
			<TextareaAutosize
				className="w-full border-none bg-transparent px-[11px] py-[7px] outline-none"
				onFocus={() => setIsFocused(true)}
				onBlur={() => setIsFocused(false)}
				value={props.value}
				onChange={props.onChange}
				placeholder={props.placeholder}
				rows={props.rows ?? 3}
				maxRows={props.maxRows}
				disabled={props.disabled}
			/>
		</div>
	);
}
